import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class EncryptionService {
  private secretKey = 'tuSemillaSecreta'; // Cambia esta clave por tu propia semilla secreta
  constructor() { }


  encrypt(data: string): string {
    const ciphertext = CryptoJS.AES.encrypt(data, this.secretKey).toString();
    return encodeURIComponent(ciphertext);
  }

  decrypt(data: string): string {
    const bytes = CryptoJS.AES.decrypt(decodeURIComponent(data), this.secretKey);
    return bytes.toString(CryptoJS.enc.Utf8);
  }
}
